<template>
  <div class="yxtbiz-skill-details">
    <training-model :evaluationList="evaluationList" :modelId="modelId" />
  </div>
</template>

<script>
import trainingModel from './components/trainingModel';

export default {
  name: 'YxtbizSkillDetails',
  components: { trainingModel },
  props: {
    modelId: String,
    evaluationList: {
      type: Array,
      default: () => []
    }
  }
};
</script>